import { PostAPI } from 'Components/Helper/Helpers';

export const Insert = async (request) => {
    return PostAPI(request, 'OperatorWiseViewProvider/Insert');
};

export const Select = async (request) => {
    return PostAPI(request, 'OperatorWiseViewProvider/Select');
};

export const Delete = async (request) => {
    return PostAPI(request, 'OperatorWiseViewProvider/Delete');
};

export const BulkDelete = async (request) => {
    return PostAPI(request, 'OperatorWiseViewProvider/BulkDelete');
};